import React from "react";
import { Link } from "react-router-dom";
import quizFailImage from "../../../asset/images/home/quiz-fail.png"; // adjust the path as needed

const QuizFail = () => {
    return (
        <>

            {/* Inline style */}
            <style>
                {`          
            /* Custom styles for the circular progress */
        .progress-ring {
            transform: rotate(-90deg);
        }

        .progress-ring__circle {
            transition: stroke-dashoffset 0.35s;
            stroke-dasharray: 251.2;
            stroke-dashoffset: 75.36; /* 70% of 251.2 */
        }

        /* Animation for the card */
        @keyframes fadeIn {
            from { opacity: 0; transform: translateY(20px); }
            to { opacity: 1; transform: translateY(0); }
        }

        .fade-in {
            animation: fadeIn 0.5s ease-out;
        }

        /* Custom gradient background */
        .card-bg {
            background: #E2F2FF;
        }

        /* Text shadow for better readability */
        .text-shadow {
            text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
        }
        `} </style>

        <div className="flex justify-center items-center min-h-screen"> <main className="bg-white p-6 sm:p-8 w-full max-w-7xl"> <h3 className="text-2xl sm:text-3xl font-bold mb-4 text-gray-700">
        Lesson 1: What is the Science of Reading? </h3>

        <h3 className="text-lg sm:text-xl font-bold text-gray-700 mb-3">Checkpoint</h3>

        <div className="border-l-2 border-gray-300 pl-4 text-gray-800 leading-relaxed mb-6 sm:text-left">
            <p>End of Quiz.</p>
        </div>

        <div className="max-w-7xl mx-auto">
            <div className="bg-white border border-primary rounded-xl pt-4 shadow-lg">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
                    {/* Left Image */}
                    <div className="flex justify-center">
                        <img
                            src={quizFailImage}
                            alt="Virtual Teacher"
                            className="max-w-full h-auto rounded-lg"
                        />
                    </div>

                    {/* Right Content */}
                    <div className="p-3">
                        <div className="card-bg rounded-2xl shadow-xl lg:pl-8 lg:pt-4 lg:pb-4 p-4 fade-in mb-5">
                            <div className="flex flex-col md:flex-row items-center">
                                {/* Circular Progress Chart */}
                                <div className="relative mb-6 md:mb-0">
                                    <svg width="120" height="120" className="progress-ring">
                                        <circle
                                            cx="60"
                                            cy="60"
                                            r="50"
                                            stroke="#e5e7eb"
                                            strokeWidth="10"
                                            fill="transparent"
                                        />
                                        <circle
                                            className="progress-ring__circle"
                                            cx="60"
                                            cy="60"
                                            r="50"
                                            stroke="#cc2010"
                                            strokeWidth="10"
                                            fill="transparent"
                                            strokeLinecap="round"
                                        />
                                    </svg>
                                    <div className="absolute inset-0 flex items-center justify-center">
                                        <span className="text-3xl font-bold text-[#cc2010]">50%</span>
                                    </div>
                                </div>

                                {/* Score Information */}
                                <div className="lg:ml-16 text-center md:text-left">
                                    <h2 className="text-2xl font-bold text-gray-800 mb-4 text-shadow text-left">
                                        Your Score
                                    </h2>
                                    <div className="space-y-2 text-xs font-bold text-gray-600 ml-3">
                                        <div className="flex">
                                            <span>Points:</span>
                                            <span className="ml-2">7/10</span>
                                        </div>
                                        <div className="flex">
                                            <span>Duration:</span>
                                            <span className="ml-2">3 minutes</span>
                                        </div>
                                        <div className="flex">
                                            <span>Results:</span>
                                            <span className="ml-2">Fail</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <h3 className="text-2xl sm:text-xl font-bold text-gray-700 mb-3">Try Again!</h3>
                        <div className="border-l-2 border-gray-300 pl-4 text-gray-800 leading-relaxed mb-6 sm:text-left">
                            <p>
                                It looks like you didn't pass the quiz this time. No worries! Just revisit the lesson and give it another shot.
                            </p>
                            <p className="mt-3">
                                You've got <span className="text-xl font-bold">4</span> attempts left!
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        {/* Retake Button */}
        <div className="flex justify-center mt-5">
            <Link to="/dashboard/modules/audio-play">
                <button className="px-6 py-3 rounded-full bg-green hover:bg-greenDark text-white font-medium">
                    Retake lesson ←
                </button>
            </Link>
        </div>
    </main>
    </div>
        </>
);
};

export default QuizFail;
